export default __webpack_public_path__ + "static/media/long_arrow_down.2223c19c.svg";